import { GuardedDeletionService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { IncidentOriginService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  IncidentOriginCreateDto,
  IncidentOriginDto,
  IncidentOriginExcelDownloadDto,
  IncidentOriginUpdateDto,
} from '../proxy/planning/dtos/incident-origin';
import { INCIDENTORIGIN_CONFIG, INCIDENTORIGIN_FIELDS } from './incident-origin.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-incident-origin',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, IncidentOriginService, ConfirmationService],
  templateUrl: './incident-origin.html',
  styleUrl: './incident-origin.scss',
})
export class IncidentOrigin extends BaseCrudComponent<
  IncidentOriginDto,
  IncidentOriginCreateDto,
  IncidentOriginUpdateDto,
  IncidentOriginExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(IncidentOriginService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('IncidentOrigin', ids),
  };
  config = INCIDENTORIGIN_CONFIG;
  fields = INCIDENTORIGIN_FIELDS;

  protected prepareUpdateDto(data: any, selected: IncidentOriginDto): IncidentOriginUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'IncidentOrigin';
  }
}
